import { render } from "./InventoryListItem.vue?vue&type=template&id=09cd6576&scoped=true&ts=true"
import script from "./InventoryListItem.vue?vue&type=script&lang=ts"
export * from "./InventoryListItem.vue?vue&type=script&lang=ts"

import "./InventoryListItem.vue?vue&type=style&index=0&id=09cd6576&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cd6576"]])

export default __exports__